import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const EditIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path stroke="currentcolor" strokeLinecap="round" d="M27.394 15.772v7.605a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6V11.48a6 6 0 0 1 6-6h5.45" />
    <path stroke="currentcolor" strokeLinecap="round" d="m10.965 16.186-1.85 5.737a1 1 0 0 0 1.306 1.242l5.274-2" />
    <path
      stroke="currentcolor"
      d="M25.03 6.728 14.18 18.032M15.726 21.13 28.572 8.286a3.434 3.434 0 1 0-4.857-4.856l-12.75 12.757M22.768 4.384l4.626 4.833M12.029 15.369l4.978 4.979"
    />
  </IconV2>
);

export default EditIcon;
